<template>
  <!-- Item do accordion do menu esquerdo. Mesma marcação de um módulo
       (.modules > .collapsible-header.module-header) para herdar altura,
       tipografia e o comportamento de abrir/fechar do M.Collapsible — a
       diferença é a imagem, que fica colorida o tempo todo. -->
  <li class="modules modules-left modules-recommendation">
    <div class="collapsible-header no-padding module-header accordion-bg-1"
      :style="($theme.darkTheme ? '' : 'background: #F2F3F7')">
      <img :src="imageSrc" class="courseImg imgMaxWidth recommendation-img" alt @error="onImageError" />
      <div class="main-module">
        <div class="module-info">
          <span class="recommendation-badge" :style="{ background: $theme.primaryColor }">
            <i class="material-icons">local_offer</i>Recomendado
          </span>
        </div>
        <div class="module-name">
          <div class="line-clamp-3">{{ product.title }}</div>
        </div>
      </div>
    </div>

    <div class="collapsible-body">
      <div class="recommendation-offer"
        :class="$theme.darkTheme ? 'is-dark' : 'is-light'">
        <div class="recommendation-headline">
          <i class="material-icons" :style="{ color: $theme.primaryColor }">auto_awesome</i>
          {{ headline }}
        </div>

        <p v-if="product.description" class="recommendation-description line-clamp-3">
          {{ product.description }}
        </p>

        <div class="recommendation-prices">
          <span v-if="hasDiscount" class="recommendation-full-price">De {{ originalPriceLabel }}</span>
          <span class="recommendation-promo-price" :style="{ color: $theme.primaryColor }">
            <template v-if="hasDiscount">Por </template>{{ salePriceLabel }}
          </span>
        </div>

        <a href="javascript:;" class="recommendation-cta waves-effect"
          :style="{ background: $theme.primaryColor }" @click.prevent="onBuy">
          Comprar
        </a>
      </div>
    </div>
  </li>
</template>

<script>
import recommendationMixin from './recommendationMixin'

export default {
  name: 'RecommendationMenuItem',
  mixins: [recommendationMixin]
}
</script>

<style scoped lang="scss">
// Os módulos comuns ficam em grayscale até abrir (.courseImg em
// ComposedHeader.vue). A recomendação usa o tratamento de "aberto" sempre.
.modules.modules-recommendation .courseImg.recommendation-img {
  filter: brightness(0.5) blur(2px);
}

.recommendation-badge {
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  color: #fff;

  .material-icons {
    font-size: 13px;
    margin-right: 4px;
    line-height: 20px;
    height: 20px;
  }
}

.recommendation-offer {
  padding: 18px 24px 22px 32px;
  display: flex;
  flex-direction: column;
  font-family: roboto;

  &.is-dark {
    background: #0d0d0d;
    color: #ffffffe5;
  }

  &.is-light {
    background: #f2f3f7;
    color: #333;
  }
}

.recommendation-headline {
  display: flex;
  align-items: center;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.3;

  .material-icons {
    font-size: 18px;
    margin-right: 8px;
    flex-shrink: 0;
  }
}

.recommendation-description {
  margin: 10px 0 0;
  font-size: 12px;
  line-height: 1.4;
  opacity: 0.8;
}

.recommendation-prices {
  display: flex;
  flex-direction: column;
  margin: 14px 0 16px;
  line-height: 1.25;
}

.recommendation-full-price {
  font-size: 13px;
  text-decoration: line-through;
  opacity: 0.6;
}

.recommendation-promo-price {
  font-size: 24px;
  font-weight: 800;
}

.recommendation-cta {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 42px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 700;
  color: #fff;
  text-decoration: none;
}
</style>
